import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-lines-two.png'

import Navbar from "../../components/navbar";
import HelpCenter from "../../components/helpCenter";
import GetInTuch from "../../components/getInTuch";
import Footer from "../../components/footer";
import FooterTopTwo from "../../components/footerTopTwo";
import ScrollTop from "../../components/scrollTop";

import { priceTwo } from "../../data/data";

import { MdOutlineCheckCircle } from '../../assets/icons/icons'

export default function PagePricing(){
    return(
        <>
        <Navbar navLight={true}/>
        <section className="bg-half-170 bg-primary d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="heading-title text-center">
                            <h2 className="text-white title title-dark mb-3">Our Pricing Plans & Rates</h2>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section">
            <div className="container">
                <div className="features-absolute">
                    <div className="row justify-content-center">
                        {priceTwo.map((item,index) =>{
                            return(
                                <div className="col-lg-4 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0" key={index}>
                                    <div className="card pricing border-0 p-4 rounded-md shadow">
                                        <div className="card-body p-2">
                                            <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">{item.title}</span>
                                            <h2 className="fw-bold mb-0 mt-3">{item.amount}</h2>
                                            <p className="text-muted">{item.time}</p>

                                            <p className="text-muted">{item.desc}</p>
            
                                            <ul className="list-unstyled pt-3 border-top">
                                                {item.features.map((el, index) =>{
                                                    return(
                                                        <li className="h6 text-muted mb-0 ms-0" key={index}><span className="text-primary h4 me-2"><MdOutlineCheckCircle className="align-middle"/></span>{el}</li>
                                                    )
                                                })}
                                            </ul>
            
                                            <div className="mt-4">
                                                <div className="d-grid">
                                                    <Link to="#" className="btn btn-primary">Buy Now</Link>
                                                </div>
                                                <p className="text-muted mt-3 mb-0">*No credit card required</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center mb-4">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">frequently asked questions</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <HelpCenter/>

                <div className="row mt-5 pt-md-5 justify-content-center">
                    <GetInTuch/>
                </div>
            </div>
        </section>
        <FooterTopTwo/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}